import { Component, OnInit,ChangeDetectorRef  } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  toasts: any[] = [];
  toast:any;
  constructor(private toastService: ToastService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.toastService.toastSubject.subscribe((toast) => {
      this.toast=toast;
      this.toasts.push(toast);
      this.cd.detectChanges();
      // Automatically remove the toast after its delay time
      //setTimeout(() => this.removeToast(toast), toast.delay || 5000);
    });

  }

  removeToast(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
